import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import DynamicSelect from "../DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "../DynamicSelect/model/DynamicSelectConfig";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import { Cie10ListService } from "./services/cie10Lists.service";
import { Http } from "@status/codes";

@Component({
  name: "SearcherField",
  components: {
    DynamicSelect
  }
})
export default class SearcherField extends Vue {
  @Prop() schema!: GroupFullSchema;
  @Prop() value!: any;

  @Inject() cie10ListService!: Cie10ListService;

  requiredFieldSelect = [FORM_VALIDATORS.REQUIRED_FIELD];
  searcherModel: {
    id: string;
    name: string;
    codeCie10?: string;
    cie10name?: string;
    cie11code?: string;
    cie11name?: string;
  }[] = [
    {
      id: "",
      name: "",
      codeCie10: "",
      cie10name: "",
      cie11code: "",
      cie11name: ""
    }
  ];
  searcherConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false,
    required: true
  };

  mounted() {
    this.preloadData(this.value);
  }

  @Watch("searcherModel", { deep: true })
  onValueChange() {
    console.log("searcherModel", this.searcherModel);
    this.$emit("update", this.searcherModel);
  }

  @Watch("schema.searcher")
  clearList() {
    this.searcherConfig.listAll = [];
  }

  loadItems(query: string) {
    console.log("query", query);
    if (this.schema.searcher == "cie10") {
      console.log("cie10----");
      this.cie10Searcher(query);
      return;
    }
    this.normalSearch(query);
  }

  async normalSearch(query: string) {
    console.log("this.schema.searcher", this.schema.searcher);
    try {
      const response = await this.cie10ListService.normalSearch(
        this.schema.searcher as string,
        query
      );
      console.log("response", response);
      if (response.code === Http.Found) {
        console.log("entro");
        this.searcherConfig.listAll = response.data.map((item: any) => {
          return {
            id: item.code,
            name: item.display
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  async cie10Searcher(query: string) {
    try {
      const response = await this.cie10ListService.cie10Search(query);
      console.log("response--->", response);
      if (response.code == Http.Found) {
        console.log("entro");
        this.searcherConfig.listAll = response.destinationEntities.map(
          (item: any) => {
            return {
              id: item.id,
              name: item.theCode + " " + item.title,
              codeCie10: item.codeCie10,
              cie10name: item.titleCie10,
              cie11code: item.theCode,
              cie11name: item.title
            };
          }
        );
        console.log("this.searcherConfig.listAll", this.searcherConfig.listAll);
      }
    } catch (error) {
      console.log(error);
    }
  }

  preloadData(value: any) {
    console.log("value", value);
    this.searcherConfig.listAll = [
      {
        id: value.id,
        name: value.name,
        codeCie10: value.codeCie10,
        cie10name: value.titleCie10,
        cie11code: value.theCode,
        cie11name: value.title
      }
    ];
    this.searcherModel = [
      {
        id: value.id,
        name: value.name,
        codeCie10: value.codeCie10,
        cie10name: value.titleCie10,
        cie11code: value.theCode,
        cie11name: value.title
      }
    ];
  }
}
